import React, { FC } from 'react';
import styled from 'styled-components';

import { TeeBookingPlayer, UpdateStatus } from '../../../database.schema';
import { useTeeBookingPlayersMutation } from '../../api/tee-booking-admin';

const Button = styled.button`
  margin 1rem 2rem;
  border-radius: 5px;
  background: lightblue;
  border: 1px solid #5c9db2;
  font-weight: 500;
  color: white;
  height: 1.5rem;
  min-width: 5rem;
  height: 2rem;
  font-size: 1rem;
  &:disabled {
    background-color: lightgray;
  }
`;
type UpdateButtonProps = {
  playerData: Array<TeeBookingPlayer>;
  setUpdateStatus: (updateStatus: UpdateStatus) => void;
  // setShowUpdate: (value: boolean) => void;
  isDisabled: boolean;
};

export const UpdateButton: FC<UpdateButtonProps> = ({ playerData, isDisabled, setUpdateStatus }) => {
  const mutation = useTeeBookingPlayersMutation();
  const saveCourse = () => {
    if (playerData) {
      const dataToSave = { players: [...playerData] };
      if (dataToSave) {
        mutation.mutate(dataToSave, {
          onSuccess: (data) => {
            setUpdateStatus({ success: true, error: false });
          },
          onError: (error) => {
            setUpdateStatus({ success: false, error: true });
            console.log('<><><>ERROR<><><><', error);
          },
        });
      }
    }
  };
  return (
    <Button data-testid="submit-course" onClick={() => saveCourse()} disabled={isDisabled}>
      Save
    </Button>
  );
};
